<template>
  <div class="row">
    <div class="availability-calendar-available-space">
      <div class="modal-dialog" style="z-index:10">
        <div class="modal-content border-0">
          <div class="modal-header pr-0">
            <h5 class="modal-title">
              <div class="d-inline mr-2">
                <i class="fas fa-calendar-plus text-white" />
              </div>
              Añadir Espacio Disponible
            </h5>
          </div>
          <div class="modal-body pr-0 py-4">
            <div class="px-2">
              <div class="my-1">
                <span class="color-gray-6 font-14 font-weight-normal">
                  Tipo de Espacio:
                </span>
                <custom-radio
                  v-model="model.spaceType"
                  class="calendar-radio-custom row mt-2"
                  field-key="value"
                  is-inline
                  :options="spaceTypeOptions"
                />
                <hr />
              </div>
              <div class="mb-3">
                <span class="color-gray-6 font-14 font-weight-normal">
                  Horario de Comienzo:
                </span>
                <validation-observer ref="startHourForm" v-slot="{ errors }">
                  <div class="row pl-3 mt-2">
                    <div class="col-1 px-0">
                      <validation-provider
                        name="hour"
                        :rules="`numeric|required|hour:${model.start.type}`"
                      >
                        <custom-input
                          v-model="model.start.hour"
                          class="calendar-available-space-input"
                          :class="{
                            'border border-danger rounded': errors.hour?.length,
                          }"
                          placeholder="0"
                          @input="onChangeStartHour"
                        />
                      </validation-provider>
                    </div>
                    <div class="col-0 px-1 pt-1">
                      :
                    </div>
                    <div class="col-1 px-0 mr-2">
                      <validation-provider
                        name="minute"
                        rules="numeric|required|quater"
                      >
                        <custom-input
                          v-model="model.start.minute"
                          class="calendar-available-space-input"
                          :class="{
                            'border border-danger rounded':
                              errors.minute?.length,
                          }"
                          placeholder="00"
                          @input="onChangeStartMinute"
                        />
                      </validation-provider>
                    </div>
                    <div class="px-0 calendar-available-space-select">
                      <select v-model="model.start.type" class="form-control">
                        <option value="AM">AM</option>
                        <option value="PM">PM</option>
                      </select>
                    </div>
                  </div>
                  <div class="row py-0 my-0">
                    <div
                      v-for="(error, key) in errors"
                      :key="key"
                      class="col-12 py-0 my-0 text-danger"
                    >
                      <span v-if="error[0] === 'Campo Requerido'">
                        El campo {{ parseErrorMessage(key) }} es requerido.
                      </span>
                      <span v-else>{{ parseErrorMessage(error[0]) }}</span>
                    </div>
                  </div>
                </validation-observer>
              </div>
              <div class="mb-3">
                <span class="color-gray-6 font-14 font-weight-normal">
                  Horario de Finalización:
                </span>
                <validation-observer ref="endHourForm" v-slot="{ errors }">
                  <div class="row pl-3 mt-2">
                    <div class="col-1 px-0">
                      <validation-provider
                        name="hour"
                        :rules="`numeric|required|hour:${model.end.type}`"
                      >
                        <custom-input
                          v-model="model.end.hour"
                          class="calendar-available-space-input"
                          :class="{
                            'border border-danger rounded':
                              errors.hour?.length ||
                              (isStartGreaterThanEnd && validated) ||
                              (isStartEqualToEnd && validated) ||
                              (isEndGreaterThan8 && validated),
                          }"
                          placeholder="0"
                          @input="onChangeEndHour"
                        />
                      </validation-provider>
                    </div>
                    <div class="col-0 px-1 pt-1">
                      :
                    </div>
                    <div class="col-1 px-0 mr-2">
                      <validation-provider
                        name="minute"
                        rules="numeric|required|quater"
                      >
                        <custom-input
                          v-model="model.end.minute"
                          class="calendar-available-space-input"
                          :class="{
                            'border border-danger rounded':
                              errors.minute?.length ||
                              (isStartGreaterThanEnd && validated) ||
                              (isStartEqualToEnd && validated) ||
                              (isEndGreaterThan8 && validated),
                          }"
                          placeholder="00"
                        />
                      </validation-provider>
                    </div>
                    <div class="px-0 calendar-available-space-select">
                      <select
                        v-model="model.end.type"
                        class="form-control"
                        :class="{
                          'border border-danger rounded':
                            (isStartGreaterThanEnd && validated) ||
                            (isStartEqualToEnd && validated) ||
                            (isEndGreaterThan8 && validated),
                        }"
                      >
                        <option value="AM">AM</option>
                        <option value="PM">PM</option>
                      </select>
                    </div>
                  </div>
                  <div class="row py-0 my-0">
                    <div
                      v-for="(error, key) in errors"
                      :key="key"
                      class="col-12 py-0 my-0 text-danger"
                    >
                      <span v-if="error[0] === 'Campo Requerido'">
                        El campo {{ parseErrorMessage(key) }} es requerido.
                      </span>
                      <span v-else>{{ parseErrorMessage(error[0]) }}</span>
                    </div>
                    <div
                      v-if="validated && isStartGreaterThanEnd"
                      class="col-12 py-0 my-0 text-danger"
                    >
                      <span>
                        La hora de finalización no puede ser menor a la hora de
                        comienzo.
                      </span>
                    </div>
                    <div
                      v-if="validated && isStartEqualToEnd"
                      class="col-12 py-0 my-0 text-danger"
                    >
                      <span>
                        La hora de finalización no puede ser igual a la hora de
                        comienzo.
                      </span>
                    </div>
                    <div
                      v-if="validated && isEndGreaterThan8"
                      class="col-12 py-0 my-0 text-danger"
                    >
                      <span>
                        La hora de finalización no puede ser mayor a las 8:00
                        PM.
                      </span>
                    </div>
                  </div>
                </validation-observer>
              </div>
            </div>
          </div>
          <div class="modal-footer px-4 d-flex justify-content-center">
            <action-button
              id="calendar-available-space-cancel-btn"
              i="fas fa-times-circle"
              variant="outline-danger px-3"
              @click="onCancel"
            >
              Cancelar
            </action-button>
            <action-button
              id="calendar-filter-apply-btn"
              i="fas fa-calendar-plus"
              variant="success px-3"
              @click="onCreate"
            >
              Crear Disponibilidad
            </action-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import CustomRadio from '@/components/common/CustomRadio';
import CustomInput from 'CustomInput';
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import moment from 'moment';

const amHourSet = [7, 8, 9, 10, 11];
const pmHourSet = [12, 1, 2, 3, 4, 5, 6, 7, 8];
const format = 'h:mm A';

extend('hour', {
  validate: (value, { type }) => {
    const number = Number(value);
    if (type === 'AM') return amHourSet.includes(number);
    if (type === 'PM') return pmHourSet.includes(number);
    return true;
  },
  params: ['type'],
  message(field, { type, _value_ }) {
    if (
      (type === 'AM' && !amHourSet.includes(_value_)) ||
      (type === 'PM' && !pmHourSet.includes(_value_))
    )
      return `El horario seleccionado no es válido.`;
    return `El campo ${field} es inválido.`;
  },
});
extend('quater', {
  validate: (value) => value % 5 === 0,
  message: 'Valores permitidos en intervalos de 5 minutos.',
});

export default {
  name: 'AvailabilityCalendarAvailableSpace',
  components: {
    ActionButton,
    CustomRadio,
    CustomInput,
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    data: {
      type: Object,
      default: () => null,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    model: {
      spaceType: true,
      start: {
        hour: null,
        minute: null,
        type: 'AM',
      },
      end: {
        hour: null,
        minute: null,
        type: 'AM',
      },
    },
    spaceTypeOptions: [
      { label: 'Disponible', value: true },
      { label: 'No disponible', value: false },
    ],
    validated: false,
  }),
  computed: {
    startHourValue() {
      const { hour, minute, type } = this.model.start;
      const time = `${hour}:${minute} ${type}`;
      return moment(time, format);
    },
    endHourValue() {
      const { hour, minute, type } = this.model.end;
      const time = `${hour}:${minute} ${type}`;
      return moment(time, format);
    },
    isStartGreaterThanEnd() {
      return this.startHourValue.isAfter(this.endHourValue);
    },
    isStartEqualToEnd() {
      return this.startHourValue.format() === this.endHourValue.format();
    },
    isEndGreaterThan8() {
      const endHour = moment('8:00 PM', format);
      return this.endHourValue.isAfter(endHour);
    },
  },
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler() {
        this.setModelFromData();
      },
    },
    model: {
      deep: true,
      handler() {
        this.validated = false;
      },
    },
  },
  mounted() {
    if (this.isMobile) {
      const backdrop = document.createElement('div');
      backdrop.classList.add('backdrop-blur');
      document.body.appendChild(backdrop);
      let backdropBlur = document.querySelector('.backdrop-blur');
      backdropBlur.style.display = 'block';
    }
  },
  beforeDestroy() {
    const backdrops = document.querySelectorAll('.backdrop-blur');
    backdrops.forEach((backdrop) => {
      document.body.removeChild(backdrop);
    });
  },
  methods: {
    async onCreate() {
      const isValidStart = await this.$refs.startHourForm.validate();
      const isValidEnd = await this.$refs.endHourForm.validate();
      this.validated = isValidStart && isValidEnd;
      if (
        !this.validated ||
        this.isStartGreaterThanEnd ||
        this.isStartEqualToEnd ||
        this.isEndGreaterThan8
      )
        return;
      this.$emit('create', { ...this.model });
    },
    onCancel() {
      this.$emit('cancel');
    },
    setModelFromData() {
      if (!this.data) return null;
      const { hour, quater, type } = this.data;
      const [hourValue, hourType] = hour.name.split(' ');
      this.model.spaceType = type !== 2;
      this.model.start.hour = hourValue;
      this.model.start.minute = quater === 0 ? '00' : quater;
      this.model.start.type = hourType;

      const endHour = quater === 45 ? Number(hourValue) + 1 : Number(hourValue);
      this.model.end.hour = endHour > 12 ? endHour - 12 : endHour;
      this.model.end.minute = quater === 45 ? '00' : quater + 5;
      this.model.end.type = endHour === 12 ? 'PM' : hourType;
    },
    parseErrorMessage(msg) {
      if (!msg) return '';
      return msg.replace('hour', 'hora').replace('minute', 'minuto');
    },
    onChangeStartHour(input) {
      const isIvalidad = isNaN(input);
      if (isIvalidad) return;

      const value = Number(input);

      if (value >= 12) {
        this.model.start.hour = 12;
        this.model.start.type = 'PM';
        return;
      }
      if (amHourSet.includes(value)) {
        this.model.start.type = 'AM';
        return;
      }
      if (pmHourSet.includes(value)) {
        this.model.start.type = 'PM';
        return;
      }
    },
    onChangeStartMinute(input) {
      const isIvalidad = isNaN(input);
      if (isIvalidad) return;

      const value = Number(input);

      if (value < 0) {
        this.model.start.minute = 0;
        return;
      }
      if (value > 45) {
        this.model.start.minute = 45;
        return;
      }
    },
    onChangeEndHour(input) {
      const isIvalidad = isNaN(input);
      if (isIvalidad) return;

      const value = Number(input);

      if ([9, 10, 11].includes(value)) {
        this.model.end.type = 'AM';
        return;
      }
      if (value >= 12) this.model.end.hour = 12;
      this.model.end.type = 'PM';
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/shared/scss/config/_colors.scss';
.availability-calendar-available-space > .modal-dialog {
  position: absolute;
  z-index: 1;
}
.availability-calendar-available-space .modal-header {
  box-shadow: 0px 3px 6px #00000029;
}
.availability-calendar-available-space .modal-footer {
  box-shadow: 0px 0px 3px #00000029 !important;
}
.availability-calendar-available-space .modal-content {
  box-shadow: 0px 2px 8px rgb(0 0 0 / 35%);
}

.availability-calendar-available-space .modal-title > div {
  padding: 6px 10px;
  border: 3px solid white;
  border-radius: 30px;
  box-shadow: 0px 3px 6px #00000029;
  background: map-get($colors, 'orange');
}

.filter-selection-tag {
  border-radius: 30px;
  font-weight: 700;
}
.filter-selection-tag > i {
  font-size: 18px;
}

.calendar-available-space-input ::v-deep input {
  font-size: 16px;
  padding: 0px 5px;
  text-align: center;
}
.calendar-available-space-select {
  width: 13%;
}
.calendar-available-space-select > select {
  font-size: 16px;
  padding: 0px 3px;
}
.modal-dialog-left-arrow::after,
.modal-dialog-right-arrow::after {
  content: ' ';
  position: absolute;
  top: 222px;
  margin-left: -5px;
  border-width: 15px;
  border-style: solid;
}
.modal-dialog-right-arrow::after {
  right: -30px;
  border-color: transparent transparent transparent white;
}

.modal-dialog-left-arrow::after {
  left: -25px;
  border-color: transparent white transparent transparent;
}

@media (max-width: 768px) {
  .availability-calendar-available-space > .modal-dialog {
    position: fixed !important;
    bottom: 0 !important;
    left: 0 !important;
    margin: 0 !important;
    top: auto !important;
    z-index: 99999999;
    min-width: 100% !important;
  }

  .modal-title {
    font-weight: 700;
  }

  .calendar-available-space-input ::v-deep input {
    font-size: 16px;
    padding: 0px 5px;
    text-align: center;
  }

  .calendar-available-space-select {
    width: 15%;
  }
  .calendar-available-space-select > select {
    font-size: 16px;
    padding: 0px 3px;
  }
}
</style>
